import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'

const LogoContainer = styled.div`
  width: 249px;
  height: 83px;
  border-radius: 10px;
  border: 2px solid #8090a8;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: ${({ padding }) => padding};
  margin: 10px;

  @media (max-width: 1199px) {
    width: 200px;
    height: 70px;
    padding: ${({ padding }) => `calc(${padding} / 1.2)`};
  }
  @media (max-width: 991px) {
    width: 140px;
    height: 50px;
    padding: ${({ padding }) => `calc(${padding} / 1.7)`};
    margin: 5px;
  }
  @media (max-width: 575px) {
    width: 210px;
    height: 75px;
    padding: ${({ padding }) => padding};
  }
  @media (max-width: 500px) {
    width: 170px;
    height: 60px;
    padding: ${({ padding }) => `calc(${padding} / 1.5)`};
  }
  @media (max-width: 410px) {
    width: 140px;
    height: 50px;
  }
  @media (max-width: 350px) {
    width: 120px;
    height: 40px;
    padding: ${({ padding }) => `calc(${padding} / 2)`};
  }
`

const Picture = styled.picture`
  width: 100%;
  height: 100%;
  display: block;
`

const Image = styled.img`
  object-fit: contain;
  width: 100%;
  height: 100%;
`

export const Logo = ({ src, padding }) => (
  <LogoContainer padding={padding}>
    <Picture>
      <source srcSet={`/partner-company-logo/${src}.webp`} type="image/webp" />
      <Image
        src={`/partner-company-logo/}${src}.png`}
        alt="company logo"
        width={100}
        height={50}
      />
    </Picture>
  </LogoContainer>
)

Logo.propTypes = {
  src: PropTypes.string.isRequired,
  padding: PropTypes.string,
}
